import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useFormik } from "formik"
import * as Yup from "yup"

// Components
import TextInput from 'components/input/TextInput'
import FileInput from 'components/input/FileInput';
import SelectInput from 'components/input/SelectInput';
import TournamentPlayerListForm from './TournamentPlayerListForm';

// Apis
import useFetch from 'utils/hooks/useFetch'
import { CREATE_REGISTRATION_TOURNAMENTS } from 'api';

import ReCAPTCHA from "react-google-recaptcha"
import mapPlayersForm from 'utils/helpers/mapPlayersForm';
import mapPlayersValidation from 'utils/helpers/mapPlayersValidation'

function TournamentRegistrationForm({ id, setIsRegistrationFormOpen, schedules, tournament }) {

  const players = mapPlayersForm({
    noOfPlayers: tournament && tournament.no_of_players || 0,
    withGameUid: tournament && tournament.with_game_uid,
    withWebullSS: tournament && tournament.with_webull_ss
  })
  
  const { t } = useTranslation();
  const { fetch: sendRegistrationForm } = useFetch(CREATE_REGISTRATION_TOURNAMENTS)

  const [isSubmiting, setIsSubmitting] = useState(false);
  const [isSubmittingDone, setIsSubmittingDone] = useState(false);

  const formik = useFormik({
    initialValues: {
      email_address: '',
      team_name: '',
      phone_number: '',
      region: '',
      team_logo: [],
      is_captcha_success: false,
      team_members: players,
      name_reserve_player: '',
      nickname_uid_reserve_player: '',
      role_reserve_player: '',
      identity_file_reserve_player: [],
      webull_account_reserve_player: [],
      game_uid_reserve_player: ''
    },
    validationSchema: Yup.object().shape({
      email_address: Yup.string().required(t('tournamentRegistrationFormValidation1')).email(t('tournamentRegistrationFormValidation2')),
      team_name: Yup.string().required(t('tournamentRegistrationFormValidation3')),
      phone_number: Yup.string().required(t('tournamentRegistrationFormValidation4')),
      team_logo: Yup.mixed().required(t('tournamentRegistrationFormValidation6')),
      is_captcha_success: Yup.boolean().required(t('tournamentRegistrationFormValidation7')),
      // ...mapPlayersValidation({
      //   Yup,
      //   noOfPlayers: players.length || 0,
      //   withGameUid: tournament && tournament.with_game_uid,
      //   withWebullSS: tournament && tournament.with_webull_ss
      // })
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: (values) => {
      const inputValues = handleInputValue(values)
      handleSubmitForm(inputValues)
    },
  });

  const handleInputValue = (values) => {
    const formData = new FormData()

    formData.append("team_details[email]", values.email_address)
    formData.append("team_details[team_name]", values.team_name)
    formData.append("team_details[region]", values.region)
    formData.append("team_details[phone_number]", values.phone_number)
    formData.append("team_details[tournament_id]", id)
    
    for (let i = 0; i < values.team_members.length; i ++) {

      formData.append(`team_members[${i}][full_name]`, values.team_members[i][`name_player_${i+1}`])
      formData.append(`team_members[${i}][nickname]`, values.team_members[i][`nickname_uid_player_${i+1}`])
      formData.append(`team_members[${i}][role]`, values.team_members[i][`role_player_${i+1}`])
      formData.append(`team_members[${i}][game_uid]`, values.team_members[i][`game_uid_player_${i+1}`])
      if (i + 1 == 1) {
        formData.append(`team_members[${i}][is_team_leader]`, true)
      } else {
        formData.append(`team_members[${i}][is_team_leader]`, false)
      }
      formData.append(`team_members[${i}][is_reserve_player]`, false)

      if (values.team_members[i][`identity_file_player_${i+1}`] && values.team_members[i][`identity_file_player_${i+1}`] instanceof File) {
        const playerName = values.team_members[i][`name_player_${i+1}`]
        const fileExtension = values.team_members[i][`identity_file_player_${i+1}`].type.split('/')[1]
        const fileName = `${playerName.split(' ').join('-').toLowerCase()}.${fileExtension}`
        formData.append('team_id_cards', values.team_members[i][`identity_file_player_${i+1}`], fileName);
      }

      if (values.team_members[i][`webull_account_player_${i+1}`] && values.team_members[i][`webull_account_player_${i+1}`] instanceof File) {
        const playerName = values.team_members[i][`name_player_${i+1}`]
        const fileExtension = values.team_members[i][`webull_account_player_${i+1}`].type.split('/')[1]
        const fileName = `${playerName.split(' ').join('-').toLowerCase()}.${fileExtension}`
        formData.append('team_webull_accounts', values.team_members[i][`webull_account_player_${i+1}`], fileName);
      }
      

    }

    if (values.name_reserve_player && values.name_reserve_player !== '') {
      formData.append(`team_members[${values.team_members.length}][full_name]`, values.name_reserve_player)
      formData.append(`team_members[${values.team_members.length}][nickname]`, values.nickname_uid_reserve_player)
      formData.append(`team_members[${values.team_members.length}][role]`, values.role_reserve_player)
      formData.append(`team_members[${values.team_members.length}][is_team_leader]`, false)
      formData.append(`team_members[${values.team_members.length}][is_reserve_player]`, true)
      formData.append(`team_members[${values.team_members.length}][game_uid]`, values.game_uid_reserve_player)
    }

    if (values.team_logo && values.team_logo instanceof File) {
      formData.append('team_logo', values.team_logo);
    }

    if (values.identity_file_reserve_player && values.identity_file_reserve_player instanceof File) {
      const playerName = values.name_reserve_player
      const fileExtension = values.identity_file_reserve_player.type.split('/')[1]
      const fileName = `${playerName.split(' ').join('-').toLowerCase()}.${fileExtension}`
      formData.append('team_id_cards', values.identity_file_reserve_player, fileName);
    }

    if (values.webull_account_reserve_player && values.webull_account_reserve_player instanceof File) {
      const playerName = values.name_reserve_player
      const fileExtension = values.webull_account_reserve_player.type.split('/')[1]
      const fileName = `${playerName.split(' ').join('-').toLowerCase()}.${fileExtension}`
      formData.append('team_webull_accounts', values.webull_account_reserve_player, fileName);
    }
    
    return formData
  }

  const handleSubmitForm = async (payload) => {
    setIsSubmitting(true)
    const newRegistration = await sendRegistrationForm({ data: payload })
    if (newRegistration && newRegistration.team_details && newRegistration.team_details.id) {
      setIsSubmitting(false)
      setIsSubmittingDone(true)
      formik.setValues((values) => ({
        email_address: '',
        team_name: '',
        phone_number: '',
        team_logo: [],
        is_captcha_success: false,
        team_members: players,
        name_reserve_player: '',
        nickname_uid_reserve_player: '',
        role_reserve_player: '',
        identity_file_reserve_player: [],
      }), false)
    }
  }

  const handleRecaptcha = (value) => {
    formik.setValues((values) => ({
      ...values,
      is_captcha_success: value && value !== '' && true
    }), false)
  }

  const handleImageAttachment = (e) => {
    e.preventDefault()
    const files = e.target.files
    const id = e.target.id
    if (files[0] && typeof files[0] !== 'undefined') {
      if (id === "team_logo") {
        formik.setValues((values) => ({
          ...values,
          team_logo: files[0]
        }), false)
      }
      for (let i = 0; i < parseInt(tournament.no_of_players || 0); i ++) {
        if (id === `team_members[${i}].identity_file_player_${i+1}`) {
          let newTeamMembers = [...formik.values.team_members]
          newTeamMembers[i][`identity_file_player_${i+1}`] = files[0]
          formik.setValues((values) => ({
            ...values,
            team_members: newTeamMembers
          }), false)
        }
        if (id === `team_members[${i}].webull_account_player_${i+1}`) {
          let newTeamMembers = [...formik.values.team_members]
          newTeamMembers[i][`webull_account_player_${i+1}`] = files[0]
          formik.setValues((values) => ({
            ...values,
            team_members: newTeamMembers
          }), false)
        }
      }
      if (id === "identity_file_reserve_player") {
        formik.setValues((values) => ({
          ...values,
          identity_file_reserve_player: files[0]
        }), false)
      }
      if (id === "webull_account_reserve_player") {
        formik.setValues((values) => ({
          ...values,
          webull_account_reserve_player: files[0]
        }), false)
      }
    }
  }

  const handleCancelRegistration = () => {
    setIsRegistrationFormOpen(false)
    formik.setValues((values) => ({
      email_address: '',
      team_name: '',
      phone_number: '',
      tournament_schedule_id: '',
      team_logo: [],
      is_captcha_success: false
    }), false)
  }

  const handleFieldValidation = (values) => {
    let result = false
    if (
      !values.email_address ||
      values.email_address === '' ||
      !values.team_name ||
      values.team_name === '' ||
      !values.phone_number ||
      values.phone_number === '' ||
      values.team_logo.length === 0 ||
      !values.is_captcha_success ||
      (tournament && tournament.with_region && (!values.region || values.region == ''))
    ) {
      result = true
    }
    for (let i = 0; i < values.team_members.length; i ++) {
      const playerName = values.team_members[i][`name_player_${i+1}`]
      const playerNickname = values.team_members[i][`nickname_uid_player_${i+1}`]
      const playerRole = values.team_members[i][`role_player_${i+1}`]
      const playerIdentity = values.team_members[i][`identity_file_player_${i+1}`]
      const playerWebullAccount = values.team_members[i][`webull_account_player_${i+1}`]
      const playerGameUid = values.team_members[i][`game_uid_player_${i+1}`]
      if (
        (!playerName || playerName == '') ||
        (!playerNickname || playerNickname == '') ||
        (!playerRole || playerRole == '') ||
        !playerIdentity
      ) {
        result = true
      }
      if (tournament && tournament.with_webull_ss && !playerWebullAccount) {
        result = true
      }
      if (tournament && tournament.with_game_uid && (!playerGameUid || playerGameUid == '')) {
        result = true
      }
    }
    return result
  }

  return (
    <section>
      <div className='w-3/4 lg:w-7/12 mx-auto space-y-4 pb-8'>
        <div>
          <p className='uppercase text-center text-lg md:text-xl xl:text-2xl font-bold text-app-blue-3'>{t('tournamentRegistrationFormTitle')}</p>
        </div>
        {isSubmittingDone ? (
          <div>
            <p className='mb-3 text-base sm:text-lg font-semibold uppercase text-app-blue-3'>{t('tournamentRegistrationFormSent')}</p>
            <button
              onClick={() => {
                setIsSubmittingDone(!isSubmittingDone)
                setIsRegistrationFormOpen(false)
              }}
              className='bg-black text-white rounded-md px-12 py-2 text-sm sm:text-base disabled:opacity-50'
            >
              OK
            </button>
          </div>
        ) : (
          <div className='space-y-4'>
            <TextInput
              name="team_name"
              label={t('tournamentRegistrationFormLabel1')}
              required
              placeholder={t('tournamentRegistrationFormPlaceholder1')}
              value={formik.values.team_name}
              onChange={formik.handleChange}
              error={formik.errors.team_name}
            />
            {
              tournament && tournament.with_region && (
                <SelectInput
                  name="region"
                  label={t('teamRegion')}
                  required
                  options={[
                    { text: "Select one..." },
                    { text: "DKI Jakarta" },
                    { text: "Jawa Barat" },
                    { text: "Jawa Tengah" },
                    { text: "Jawa Timur" },
                    { text: "D.I Yogyakarta" },
                    { text: "Banten" }
                  ]}
                  value={formik.values.region}
                  onChange={formik.handleChange}
                  // error={errorSelectInput}
                />
              )
            }
            <TextInput
              name="email_address"
              label={t('tournamentRegistrationFormLabel2')}
              required
              placeholder={t('tournamentRegistrationFormPlaceholder2')}
              value={formik.values.email_address}
              onChange={formik.handleChange}
              error={formik.errors.email_address}
            />
            <TextInput
              name="phone_number"
              label={t('tournamentRegistrationFormLabel3')}
              required
              placeholder={t('tournamentRegistrationFormPlaceholder3')}
              value={formik.values.phone_number}
              onChange={formik.handleChange}
              error={formik.errors.phone_number}
            />
            <TextInput
              label={t('tournament')}
              disabled={true}
              value={tournament && tournament.title}
            />
            <FileInput
              name="team_logo"
              label={t('tournamentRegistrationFormLabel5')}
              required
              value={formik.values.team_logo}
              onChange={handleImageAttachment}
              error={formik.errors.team_logo}
            />
            <TournamentPlayerListForm
              value={formik.values}
              error={formik.errors}
              onChange={formik.handleChange}
              handleIdentityFile={handleImageAttachment}
              teamMembers={players}
              tournament={tournament}
            />
            <div className='flex justify-center py-4'>
              <ReCAPTCHA
                sitekey="6Le7pvUaAAAAAAiPYg6vfzaD7kFju2jFBEYuvvaK"
                onChange={handleRecaptcha}
              />
            </div>
            <div className='flex flex-col justify-center gap-2'>
              <div>
                <button
                  onClick={formik.handleSubmit}
                  className='w-full bg-black text-white rounded-md px-12 py-[10px] text-sm sm:text-base disabled:opacity-50'
                  disabled={handleFieldValidation(formik.values)}
                  type='button'
                >
                  {isSubmiting && (
                    <svg aria-hidden="true" className="inline mb-[4px] mr-2 w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                    </svg>
                  )}
                  {t('tournamentRegistrationFormSubmitButton')}
                </button>
              </div>
              <div>
                <button
                  onClick={() => handleCancelRegistration()}
                  className='w-full bg-transparent border border-black border-2 font-bold rounded-md px-12 py-2 text-sm sm:text-base hover:bg-gray-200'
                >
                  {t('tournamentRegistrationFormCancelButton')}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default TournamentRegistrationForm
